<template>
  <v-navigation-drawer app class="asta-drawer" v-model="drawer" fixed temporary>
    <div class="drawer-header navy">
      <v-avatar class="drawer-user-avatar" size="34">
        <v-img v-if="user_pic" contain :src="user_pic"></v-img>
        <v-icon v-else color="white">account_circle</v-icon>
      </v-avatar>

      <div class="drawer-user-info">
        <div class="drawer-user-name white--text">
          {{ user_displayName || user_uid }}
        </div>
        <div class="drawer-league-row secondary--text">
          <v-icon x-small class="drawer-league-icon secondary--text">
            security
          </v-icon>
          <span class="drawer-league-name">
            {{ asta_info.name }}
          </span>
        </div>
      </div>

      <v-spacer></v-spacer>
      <v-btn rounded class="white--text" icon @click="toggle">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>

    <div
      class="error white--text pa-2 ma-2"
      style="border-radius: 3px"
      v-if="!admin && !my_squadra"
    >
      Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori
      e gli ospiti non possono parteciparvi ma possono seguirne l'andamento.
    </div>

    <v-list dense>

            <!-- sblocca -->
      <v-list-item link @click="promptSblocco" v-if="!premium">
        <v-list-item-icon>
          <v-icon color="orange">workspace_premium</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Asta Live senza limiti</v-list-item-title
          >
          <v-list-item-subtitle class="orange--text">
            <div v-if="asta_info.counter">
              Hai ancora <b>{{ asta_info.counter }}</b> assegnazioni.
            </div>
            <div v-else>Sblocca per continuare.</div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- La mia squadra  -->
      <v-list-group v-if="my_squadra" :value="false" class="drawer-team-group">
        <template v-slot:activator>

        <v-list-item-icon>
          <v-icon color="text">admin_panel_settings</v-icon>
        </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="drawer-team-title font-weight-bold">
              La mia squadra
            </v-list-item-title>
            <v-list-item-subtitle class="drawer-team-subtitle">
              {{ mySquadraName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <!-- Avatar -->
        <v-list-item class="drawer-team-action" link @click="gotoUser">


          <v-list-item-content>
            <v-list-item-title class="drawer-team-action-title font-weight-bold">
              Modifica avatar
              <v-icon x-small color="text">open_in_new</v-icon>
            </v-list-item-title>
            <v-list-item-subtitle class="drawer-team-action-subtitle">
              Poi clicca 'Modifica' per caricare foto
            </v-list-item-subtitle>
          </v-list-item-content>

            <!-- <v-list-item-avatar class="drawer-team-action-icon"> -->
            <!-- <squadra-crediti :id="user_uid" xxSmall hideName></squadra-crediti> -->
              <v-avatar size="32">
                <v-img contain :src="user_pic"></v-img>
            </v-avatar>
          <!-- </v-list-item-avatar> -->



        </v-list-item>

        <!-- nome squadra -->
        <v-list-item class="drawer-team-action" link @click="gotoNomeSquadra">
          <!-- <v-list-item-avatar class="drawer-team-action-icon">
            <v-icon color="text">abc</v-icon>
          </v-list-item-avatar> -->

          <v-list-item-content>
            <v-list-item-title class="drawer-team-action-title font-weight-bold">
              Modifica nome
              <v-icon x-small color="text">open_in_new</v-icon>
            </v-list-item-title>
            <v-list-item-subtitle class="drawer-team-action-subtitle">
              {{ mySquadraName }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <!-- presidente-->
        <v-list-item class="drawer-team-action" link @click="gotoGestoreSquadra">
          <!-- <v-list-item-avatar class="drawer-team-action-icon">
            <v-icon color="text">supervised_user_circle</v-icon>
          </v-list-item-avatar> -->

          <v-list-item-content>
            <v-list-item-title class="drawer-team-action-title font-weight-bold">
              Modifica presidente
              <v-icon x-small color="text">open_in_new</v-icon>
            </v-list-item-title>
            <v-list-item-subtitle class="drawer-team-action-subtitle">
              Solo i presidenti giocano in Asta Live <br />Non i cogestori
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <!-- pianifica -->
        <v-list-item class="drawer-team-action" link @click="showPlan">
          <!-- <v-list-item-avatar class="drawer-team-action-icon">
            <v-icon color="text">design_services</v-icon>
          </v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title class="drawer-team-action-title font-weight-bold">
              Pianifica crediti
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

       <!-- salva rose -->
      <v-list-item
        link
        class="drawer-save-assignments"
        @click="promptSaveRoseFromDrawer"
        v-if="is_mobile"
      >
        <v-list-item-icon>
          <v-icon class="white--text">save</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold white--text"
            >Salva assegnazioni/rose</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        @click="checkAllineamentoRoseFromDrawer"
        v-if="is_mobile && !Config.STANDALONE"
      >
        <v-list-item-icon>
          <v-icon color="text">sync</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Riallineamento rose/crediti</v-list-item-title
          >
           <v-list-item-subtitle>
            Clicca per saperne di piú
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>


      <!-- Impostazioni -->
      <!-- <v-list-item link @click="promptImpostazioni">
        <v-list-item-icon>
          <v-icon color="text">settings</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Impostazioni asta</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item> -->

      <!-- download -->
      <v-list-item link @click="promptDownloadRose" v-if="my_squadra">
        <v-list-item-icon>
          <v-icon color="text">download</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Download Rose</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

       <!-- Amministratore asta -->
      <v-list-item
        link
        v-if="my_squadra && !isAdminSet"
        @click="promptChangeAdmin"
      >
        <v-list-item-icon>
          <v-icon color="text">engineering</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Nessun amministratore
          </v-list-item-title>
          <div class="error--text">Imposta amministratore d'asta</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        v-else-if="my_squadra && isAdminSet"
        @click="promptChangeAdmin"
      >
        <v-list-item-icon>
          <v-icon color="text">engineering</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Amministratore Asta
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ adminUsername }}
            <div class="stato" :class="adminPresenceClass"></div
          ></v-list-item-subtitle>
          <div
            :class="{
              'error--text': adminPresence != Constants.PRESENCE_STATES.ONLINE,
            }"
          >
            L'amministratore d'asta deve rimanere sempre online durante il corso
            dell'asta o Asta Live si bloccherà.
          </div>
        </v-list-item-content>
      </v-list-item>

      <!-- Stato mercato Asta Live -->
      <v-list-item
        v-if="my_squadra"
        link
        @click="promptStatiMercati"
      >
        <v-list-item-icon>
          <v-icon color="text">outlined_flag</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Mercato Asta Live
          </v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold" :style="statoMercatoStyle">
            {{ statoMercatoText }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>


      <!-- Come funziona -->
      <v-list-item link @click="promptComeFunziona">
        <v-list-item-icon>
          <v-icon color="text">not_listed_location</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Come funziona?</v-list-item-title
          >
          <v-list-item-subtitle class=""
            >Guida veloce a Asta Live</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Supporto -->
      <v-list-item link>
        <v-list-item-icon>
          <v-icon color="text">support </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            ><a
              class="blue-grey--text text-decoration-none"
              href="https://www.facebook.com/groups/500245610367729/"
              target="_blank"
              >Supporto</a
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Novità -->
      <v-list-item link class="drawer-news-icon" @click="promptChangeLog">
        <v-list-item-icon>
          <v-icon color="text">new_releases</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Novità Asta Live
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- weblink -->
      <v-list-item link v-if="is_mobile" @click="gotoAsta">
        <v-list-item-icon>
          <v-icon color="text">language</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold"
            >Web link
            <v-icon x-small right class="text--text"
              >open_in_new</v-icon
            ></v-list-item-title
          >
          <v-list-item-subtitle
            >Asta Live è disponibile anche in<br />
            una più comoda versione desktop<br />
            <span
              class="text--text text--lighten-2 text-decoration-underline"
              >{{ urlAsta }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div class="text-center">
      <v-btn small rounded outlined v-clipboard:copy="urlAsta" v-if="is_mobile">
        Copia link
      </v-btn>
    </div>

       <v-alert
        v-if="classic && !Config.STANDALONE"
        class="standalone-promo mx-2 my-2"
        color="cyan darken-3"
        dense
        text
      >
        <div class="cyan--text">
           <v-icon class="mr-2" color="cyan">
                    campaign
                  </v-icon>
                  Asta Live è per tutti!</div>
        <div>
          Vorresti usare Asta Live ma giochi con i <b>ruoli Mantra</b>
          o giocate su <b>altre piattaforme</b>?<br>Prova
          <v-btn
            small
            depressed
            href="https://asta-live.com"
            target="_blank"
             class="cyan lighten-1 white--text ml-1"
          >asta-live.com  <v-icon x-small class="ml-1" color="white">open_in_new</v-icon></v-btn>.<br>
        </div>
      </v-alert>

    <div class="version">
      <small>{{ version }}</small>
    </div>

    <!-- premium -->
    <!-- <div id="area-acquisto" v-if="!premium">
        <div v-if="asta_info.counter">
          Prova subito Asta Live! Usando questa versione <b>FREE</b> è possibile
          fare l'asta ancora per <b>{{ asta_info.counter }}</b>
          calciatori. Sblocca subito per non avere limiti.
        </div>
        <div v-else>
          Hai terminato le assegnazioni <b>FREE</b> dei calciatori. Sblocca
          l'asta per continuare.
        </div>
        <v-btn
          rounded
          class="orange white--text mt-1 mx-auto"
          v-if="!premium"
          @click="promptSblocco"
        >
          <v-icon small left>verified</v-icon>
          SBLOCCA
        </v-btn>
      </div> -->
  </v-navigation-drawer>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import Config from "../../config-app/config";

import AstaChooser from "./dialogs/AstaChooser";
import SquadraCrediti from "./common/SquadraCrediti";

export default {
  name: "asta-drawer",
  mixins: [mixins, toast],
  components: {
    AstaChooser,
    SquadraCrediti,
  },

  mounted() {
    console.log("--> AstaDrawer mounted.");
    db.on("toggleDrawer", this.toggle);
    db.on("closeDrawer", this.toggle);
  },

  computed: {
    // user_pic2(){
    //   return "https://nations-devfpz.s3.eu-west-1.amazonaws.com/files/public/pictures/no-hexatar.png"
    // },
    urlAsta() {
      return (
        Config.HOST + "/pages/asta-live/main.php?ID_Lega=" + this.asta_info.id
      );
    },
    // mySquadra() {
    //   return this.asta_squadre[this.user_uid];
    // },
    mySquadraName() {
      return this.my_squadra ? this.asta_squadre[this.user_uid].name : "";
    },
    drawerClass() {
      return {
        "navigation-drawer--close": !this.drawer,
        "navigation-drawer--open": this.drawer,
      };
    },
    // shouldShowPlan() {
    // },
    statoMercatoText() {
      const text =
        this.asta_info.statoMercato == Constants.MERCATO_ATTIVO
          ? "Attivo"
          : "Non attivo";
      return `${text}`.toUpperCase();
    },
    statoMercatoStyle() {
      return this.asta_info.statoMercato == Constants.MERCATO_ATTIVO
        ? { }
        : { color: "var(--v-error-base)" };
    },
    ...Vuex.mapGetters([
      "migliore_offerta",
      // "asta_choosers",
      "svincolati_ids",
      "user_claims",
      "tot_squadre",
      "is_mobile",
      "version",
      "user_displayName",
      "user_pic",
      "user_uid",
    ]),
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    gotoUser() {
      window.open(Config.HOST + "/user/" + this.fp_uid(this.user_uid));
    },

    gotoNomeSquadra() {
      window.open(
        Config.HOST +
          "/fantacalcio/gestione-squadra-alias/" +
          this.my_squadra?.ID_Squadra
      );
    },
    gotoAsta() {
      window.open(this.urlAsta);
    },

    // gotoAdminLega() {
    //   window.open(
    //     Config.HOST + "/fantacalcio/gestione-lega/admin/" + this.asta_info.id
    //   );
    // },
    gotoGestoreSquadra() {
      window.open(
        Config.HOST +
          "/fantacalcio/gestione-squadra-aggiungi-gestore/" +
          this.my_squadra?.ID_Squadra
      );
    },
    promptComeFunziona() {
      db.emit("showComeFunziona");
    },
    promptSblocco() {
      db.emit("showSblocco");
    },
    promptImpostazioni() {
      db.emit("showImpostazioni");
      this.drawer = false;
    },
    promptStatiMercati() {
      db.emit("showStatiMercati");
      this.drawer = false;
    },
    promptChangeLog() {
      db.emit("showChangeLog");
      this.drawer = false;
    },
    promptDownloadRose() {
      db.emit("promptDownloadRose");
    },
    promptSaveRoseFromDrawer() {
      this.promptSaveRose();
      this.drawer = false;
    },
    checkAllineamentoRoseFromDrawer() {
      this.checkAllineamentoRose(true);
      this.drawer = false;
    },
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    toggle() {
      this.drawer = !this.drawer;
    },
    close() {
      this.drawer = false;
    },
    showPlan() {
      this.close();
      if (this.is_mobile) {
        db.emit("showDialogPlan");
      }
    },
  },
  destroyed() {
    console.log("<-- AstaDrawer destroyed.");
    db.off("toggleDrawer", this.toggle);
    db.off("closeDrawer", this.toggle);
  },
};
</script>

<style scoped>
.asta-drawer {
  width: 330px !important;
}

.drawer-header {
  display: flex;
  align-items: center;
  min-height: 70px;
  padding: 0 8px;
  flex: 0 0 auto;
}

.drawer-user-avatar {
  flex: 0 0 auto;
  margin-right: 8px;
}

.drawer-user-info {
  flex: 1 1 auto;
  min-width: 0;
}

.drawer-user-name,
.drawer-league-row,
.drawer-league-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-user-name {
  font-weight: 700;
}

.drawer-league-row {
  align-items: center;
  display: flex;
  font-size: 12px;
  line-height: 1.2;
}

.drawer-league-icon {
  flex: 0 0 auto;
  margin-right: 3px;
}

.drawer-league-name {
  min-width: 0;
}

.drawer-save-assignments {
  border-radius: 6px;
  margin: 6px 8px;
  border: 1px solid var(--v-primary-darken1);
  background-color: var(--v-primary-base);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
  &:hover{
    box-shadow: 0 5px 22px 0 rgba(0, 0, 0, .2)
  }
}

.standalone-promo {
  font-size: 12px;
  line-height: 1.25;
}

/* .standalone-promo-title {
  color: var(--v-navy-base);
  font-weight: 700;
  margin-bottom: 3px;
} */

.drawer-team-group {
  /* margin: 2px 0 8px; */
}

.drawer-team-group::v-deep > .v-list-group__header {
  /* border: 0.5px solid var(--v-navy-base);
  border-radius: 6px;
  min-height: 52px;
  margin: 0 8px;
  padding-left: 8px;
  padding-right: 6px; */
  /* background-color: var(--v-grey-lighten3); */
}


.drawer-team-group::v-deep .v-list-group__items {
  background-color: transparent !important;
}

.drawer-team-avatar {
  margin-right: 8px !important;
}

.drawer-team-title {
  color: var(--v-navy-base);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.15;
}

.drawer-team-subtitle {
  color: var(--v-text-base) !important;
  font-size: 12px;
  line-height: 1.2;
}

.drawer-team-title,
.drawer-team-subtitle,
.drawer-team-action-title,
.drawer-team-action-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-team-action {
  border-left: 0.5px solid var(--v-text-base);
  margin: 0px 8px 0 28px;
  min-height: 46px;
  padding-left: 8px !important;
}

.drawer-team-action::v-deep .v-list-item__content {
  min-width: 0;
}

.drawer-team-action-icon {
  height: 26px !important;
  margin-right: 10px !important;
  min-width: 26px !important;
  width: 26px !important;
}

.drawer-team-action-title {
  color: var(--v-navy-base);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.15;
}

.drawer-team-action-subtitle {
  color: var(--v-text-base) !important;
  font-size: 11px;
  line-height: 1.15;
}

.asta-drawer::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}

.asta-drawer::v-deep .v-navigation-drawer__content > * {
  flex: 0 0 auto;
}

.version {
  flex: 0 0 auto;
  margin-top: auto;
  padding: 8px 0;
  text-align: center;
}

</style>
